import { render, staticRenderFns } from "./buttons-text.vue?vue&type=template&id=bbcf5218&scoped=true"
import script from "./buttons-text.vue?vue&type=script&lang=js"
export * from "./buttons-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcf5218",
  null
  
)

export default component.exports